// libs
import classNames from "classnames";
import { useTranslations } from "next-intl";

type ErrorProps = {
  text: string;
  className?: string;
};

const Error = ({ text, className }: ErrorProps) => {
  const t = useTranslations();

  return (
    <div
      className={classNames(
        "mt-1 flex justify-start pl-8 text-xs font-normal text-red-600",
        className,
      )}
    >
      {text && t(text)}
    </div>
  );
};

export { Error };
